import React, { Component } from "react";

import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";

export default class Confirm extends Component {
  // A bit of state to give the user feedback while their email
  // address is being confirmed on the User model on the server.
  state = {
    confirming: true,
    error: false,
    message: "",
  };

  // When the component mounts the mongo id for the user is pulled  from the
  // params in React Router. This id is then sent to the server to confirm that
  // the user has clicked on the link in the email. The link in the email will
  // look something like this:
  //
  // http://localhost:3000/confirm/5c40d7607d259400989a9d42
  //
  // where 5c40d...a9d42 is the unique id created by Mongo
  componentDidMount = () => {
    const { id } = this.props.match.params;
    const { REACT_APP_MY_ENV } = process.env;

    fetch(`${REACT_APP_MY_ENV}email/confirm/${id}`)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          confirming: data.confirming,
          message: data.message,
          error: data.error,
        });
      })
      .catch((err) => console.log(err));
  };

  // While the email address is being confirmed on the server a spinner is
  // shown that gives visual feedback. Once the email has been confirmed the
  // spinner is stopped and turned into a button that takes the user back to the
  // <Landing > component so they can confirm another email address.
  render = () => (
    <div className="confirm">
      {this.state.confirming ? (
        <Typography align="center" variant="h1" paragraph="true">
          Validando correo. {this.state.message === "" ? "" : "Razon: "}{" "}
          {this.state.message}
        </Typography>
      ) : (
        <Link to="/">
          <Typography align="center" variant="h1" paragraph="true">
            Correo validado, haga click aqui para regresar al inicio.
          </Typography>
        </Link>
      )}
    </div>
  );
}
